export const pX = (v) => ({ paddingLeft: v, paddingRight: v });
export const mX = (v) => ({ marginLeft: v, marginRight: v });
export const pY = (v) => ({ paddingTop: v, paddingBottom: v });
export const mY = (v) => ({ marginTop: v, marginBottom: v });
